// Vendor Libraries
import { ElementRef } from '@angular/core';
// Services
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import * as i0 from "@angular/core";
import * as i1 from "../fundamental-chart/components/fundamental-chart/fundamental-chart.component";
/**
 * Effectively a utility class that allows our django templated content to boostrap the FundamentalChartComponent
 * directive.
 */
export class BareFundChartWrapperComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.chartId = '';
        this.chartDataUrl = '';
        this.chartFormData = {};
        this.chartJsonData = {};
        this.chartAnnotations = [];
        this.noDataClass = '';
        this.noDataHtml = '';
        this.sidebarOpen = '';
        this.chartOptions = {};
        this.chartTabUrl = '';
        this.chartId = this.eltRef.nativeElement.getAttribute('chartId');
        this.chartDataUrl = this.eltRef.nativeElement.getAttribute('chartDataUrl');
        this.chartFormData = JSON.parse(this.eltRef.nativeElement.getAttribute('chartFormData') || '{}');
        this.chartJsonData = JSON.parse(this.eltRef.nativeElement.getAttribute('chartJsonData') || '{}');
        this.chartAnnotations = JSON.parse(this.eltRef.nativeElement.getAttribute('chartAnnotations'));
        this.noDataClass = this.eltRef.nativeElement.getAttribute('noDataClass');
        this.noDataHtml = this.eltRef.nativeElement.getAttribute('noDataHtml');
        this.sidebarOpen = this.eltRef.nativeElement.getAttribute('sidebarOpen');
        this.chartOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('chartOptions'));
        this.configurableOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('configurableOptions'));
        this.chartTabUrl = JSON.parse(this.eltRef.nativeElement.getAttribute('chartTabUrl'));
    }
    handleClick() {
        if (this.chartTabUrl) {
            window.location = this.chartTabUrl;
        }
    }
}
BareFundChartWrapperComponent.ɵfac = function BareFundChartWrapperComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BareFundChartWrapperComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
BareFundChartWrapperComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BareFundChartWrapperComponent, selectors: [["ycn-bare-fund-chart-wrapper"]], inputs: { chartId: "chartId", chartDataUrl: "chartDataUrl", chartFormData: "chartFormData", chartJsonData: "chartJsonData", chartAnnotations: "chartAnnotations", noDataClass: "noDataClass", noDataHtml: "noDataHtml", sidebarOpen: "sidebarOpen", chartOptions: "chartOptions", configurableOptions: "configurableOptions", chartTabUrl: "chartTabUrl" }, standalone: false, features: [i0.ɵɵProvidersFeature([ChartZoomService])], decls: 2, vars: 3, consts: [[1, "full-height"], ["noDataClass", "get-started-border", 1, "chart-canvas", "d-flex", "flex-column", 3, "chartClickHandler", "configurableOptions", "chartOptions", "chartJsonData"]], template: function BareFundChartWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ycn-fundamental-chart", 1);
        i0.ɵɵlistener("chartClickHandler", function BareFundChartWrapperComponent_Template_ycn_fundamental_chart_chartClickHandler_1_listener() { return ctx.handleClick(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("configurableOptions", ctx.configurableOptions)("chartOptions", ctx.chartOptions)("chartJsonData", ctx.chartJsonData);
    } }, dependencies: [i1.FundamentalChartComponent], encapsulation: 2 });
